// Preserve every stored event; only a failed attempt immediately retried is collapsed visually.
export function visibleCopilotMessages<T extends {role:string;text:string;run_status?:string|null}>(messages:T[]):T[] {
  return messages.filter((message,index)=>{
    const next=messages[index+1];
    return !(message.role==='owner' && message.run_status==='failed' && next?.role==='owner' && message.text===next.text);
  });
}
